import { z } from "zod/v4"

export const QuillDeltaServerSchema = z.record(z.string(), z.unknown()).describe("Quill Delta形式")

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type QuillDelta = any
